// Injected by RetryChunkLoadPlugin: retry failed async chunk loads
(function () {
    var maxRetries = 3;
    var initialDelay = 300;
    var originalLoad = __webpack_require__.l;
    if (typeof originalLoad !== 'function') { return; }
    __webpack_require__.l = function (url, done, key, chunkId) {
        var attempt = 0;
        var run = function () {
            var target = url;
            if (attempt > 0) { target = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'chunk-retry=' + attempt; }
            originalLoad(target, function (event) {
                if (event && event.type !== 'load' && attempt < maxRetries) {
                    attempt++;
                    setTimeout(run, initialDelay * attempt);
                    return;
                }
                done(event);
            }, key, chunkId);
        };
        run();
    };
})();